import { Component, ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

const FallbackContainer = styled.div`
  padding: 20px;
  text-align: center;
`

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <FallbackContainer>
            <h2>Something went wrong.</h2>
            <p>Please refresh the page or contact support if the problem persists.</p>
            <button onClick={() => window.location.reload()}>Refresh Page</button>
          </FallbackContainer>
        )
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
